import React, { useState } from "react"
import "./ContactForm.css"
import MapSelect from "../MapSelect/MapSelect"
import { toast } from "sonner"

export default function ContactForm() {
  const [formData, setFormData] = useState({
      name: '',
      email: '',
      phone: '',
      localidad: '',
      mensaje: '',
    })

  const submitToGoogleForm = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.phone || !formData.localidad || !formData.mensaje) {
      toast.error("Por favor completa todos los campos");
      return;
    }

    // Validar el formato del email
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(formData.email)) {
      toast.error("Por favor ingresa un correo electrónico válido");
      return;
    }

    // Validar el formato del teléfono
    if (formData.phone.length < 6 || isNaN(formData.phone)) {
      toast.error("Por favor ingresa un número de teléfono válido");
      return;
    }

    // Validar el campo localidad
    if (formData.localidad === "") {
      toast.error("Por favor selecciona una localidad");
      return;
    }
    // Validar el campo mensaje
    if (formData.mensaje.length < 10) {
      toast.error("Por favor ingresa un mensaje válido");
      return;
    }
  
    try {
      await fetch("https://docs.google.com/forms/d/e/1FAIpQLSduV8_GcDnikF1_ldT0M2oLQEHsLKPzU237OR7en4optMlMcA/formResponse", {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: new URLSearchParams({
          "entry.1683401288": formData.name,
          "entry.1804338596": formData.email,
          "entry.809070989": formData.phone,
          "entry.1258843485": formData.localidad,
          "entry.1378580218": formData.mensaje
        }).toString()
      })
      toast.success("Formulario enviado correctamente")
    } catch (error) {
      console.error("Error al enviar el formulario", error)
      toast.error("Error al enviar el formulario")
    }
  }

  return (
    <div className="contact-container">
      {/* Sección del mapa */}
      <MapSelect />

      {/* Sección del formulario */}
      <div className="form-container">
        <form className="form" onSubmit={submitToGoogleForm}>
          <input
            type="text"
            placeholder="Nombres y Apellidos"
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />
          <input
            type="tel"
            placeholder="Teléfono"
            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          />
          <input
            type="email"
            placeholder="Email"
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          />
          <select defaultValue="" onChange={(e) => setFormData({ ...formData, localidad: e.target.value })}>
            <option value="" disabled>Selecciona sucursal</option>
            <option value="etruria">Etruria</option>
            <option value="carlota">La Carlota</option>
          </select>
          <textarea onChange={(e) => setFormData({ ...formData, mensaje: e.target.value })} placeholder="Tus consultas o comentarios"></textarea>
          <button type="submit">Contactar Ahora</button>
        </form>
      </div>
    </div>
  )
}